/**
 * 草图运行时历史恢复提交原因。
 *
 * 说明：undo/redo 恢复运行时快照时需要刷新草图组内部索引和渲染状态，
 * 但它不是一次新的用户建模编辑，不能再次触发特征重建或引用重建。
 */
export const HISTORY_SKETCH_RUNTIME_RESTORE_COMMIT_REASON = 'history-sketch-runtime-restore';

/**
 * 草图实体缩放提交原因。
 *
 * 缩放会同时改变该草图作为引用来源和引用目标时的几何关系，
 * 引用协调器据此按参与草图统一重建两侧引用。
 */
export const SKETCH_SCALE_ENTITIES_COMMIT_REASON = 'sketch.runtime.scale-entities';
